
//==================BEGIN DEPENDENCIES========================

import 'jquery';
  
import 'reflect-metadata';
  

//==================BEGIN UTILITY========================

import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/utility/js/namespace';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/utility/js/utils';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/utility/js/tests';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/utility/js/observe-dom';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/utility/ab-logger/js/ab-logger';
  

//==================BEGIN PLUGINS========================

import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/pictureFill/js/pictureFill';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.min';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.auto.min';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/controller/js/controller';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/enquireJs/js/enquire';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/controller/js/enquireIt';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/truncate/js/truncate';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/magicSearch/js/magicsuggest';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/transplant/js/transplant';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/dotdotdot/js/dotdotdot';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/pagination/js/client-pagination';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/sortable-table/js/sortable-table';
  

//==================BEGIN VARIABLES========================

import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/variables/js/grid-variables';
  

//==================BEGIN BASIC========================

import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/basic/lists/js/list';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/basic/base/js/pageBody';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/basic/inputs/js/inputs';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/basic/base/js/base';
  

//==================BEGIN COMPONENTS========================

import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/raa/templates/email/js/email';
  
import GetFTR from '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/getFTR/js/getFTR';  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/modal/js/modal';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/navigation/js/hubpage-menu';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/popover/js/popover';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/tooltip/js/tooltip';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/teaser/js/teaser';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/article-actions-bar/js/article-action-bar';
  
import CollapsibleList from '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/collapsibleList/js/collapsibleList';  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/commerce/widgets/billing/js/billing';
  
import Payment from '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/commerce/widgets/payment/js/payment';  

//==================BEGIN WIDGETS========================

import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/access-denial/js/access-denial';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/share-access/js/share-access';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/cover-image/js/cover-image';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/cookie-policy-popup/js/cookie-policy-popup';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/ip-ranges/js/ip-ranges';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/media/js/youtube-media';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/download-marc-form-v2/js/marc';
  

//==================BEGIN TEMPLATES========================

import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/templates/toc/js/toc';
  
import Journal from '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/templates/journal/js/journal';  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/templates/homePage/js/home';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/templates/footer/js/footer';
  

//==================BEGIN GROUPS========================

import './groups/_jquery';

import tabsMain from './groups/_tabs';
const main = (UX) => {
    const $transplant = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="transplant"]')),
        $sortableTable = Array.prototype.slice.call(document.getElementsByClassName('table--sortable')),
        $list = Array.prototype.slice.call(document.getElementsByClassName('expandable-list')),
        $email = document.getElementById('fakeEmail'),
        $getFTR = Array.prototype.slice.call(document.querySelectorAll('[data-getFTR-references-enabled], [data-getFTR-citedby-enabled]')),
        $modal = Array.prototype.slice.call(document.querySelectorAll('.modal, [data-toggle="modal"]')),
        $popover = Array.prototype.slice.call(document.querySelectorAll('.ipopover, .popover')),
        $articleActionsbar = Array.prototype.slice.call(document.getElementsByClassName('article-actionbar')),
        $CollapsibleList = Array.prototype.slice.call(document.getElementsByClassName('collapsible-menu')),
        $payment = Array.prototype.slice.call(document.querySelectorAll('.payment,.checkoutPaymentList')),
        $accessDenial = Array.prototype.slice.call(document.getElementsByClassName('slotLicenseConsumption')),
        $shareAccess = Array.prototype.slice.call(document.getElementsByClassName('share-access')),
        $sliderTabs = Array.prototype.slice.call(document.getElementsByClassName('loc.swipe__list')),
        $cookiePolicyPopupWidget = Array.prototype.slice.call(document.getElementsByClassName('cookiePolicy-popup')),
        $ipRanges = Array.prototype.slice.call(document.getElementsByClassName('ip-ranges')),
        $marc = Array.prototype.slice.call(document.getElementsByClassName('marc-v2')),
        $journal = Array.prototype.slice.call(document.querySelectorAll('.journal-page-body, .journal-body')),
        $backToTop = Array.prototype.slice.call(document.getElementsByClassName('back-to-top'))

try {
        UX.controller.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($transplant.length ) {
            UX.transplant.init($transplant);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sortableTable.length ) {
            UX.sortableTable.init($sortableTable);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($list.length ) {
            UX.list.init($list);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.pageBody.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.fieldsCtrl.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($email ) {
            UX.email.init($email);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($getFTR.length ) {
            UX.getFTR = new GetFTR($getFTR).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($modal.length ) {
            UX.modal.init($modal);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($popover.length ) {
            UX.popover.init($popover);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.tooltip.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($articleActionsbar.length ) {
            UX.articleActionsbar.init($articleActionsbar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($CollapsibleList.length ) {
            UX.CollapsibleList = new CollapsibleList($CollapsibleList).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($payment.length ) {
            UX.payment = new Payment($payment)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($accessDenial.length ) {
            UX.accessDenial.init($accessDenial);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($shareAccess.length ) {
            UX.shareAccess.init($shareAccess);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sliderTabs.length ) {
            UX.sliderTabs.init($sliderTabs);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($cookiePolicyPopupWidget.length ) {
            UX.cookiePolicyPopupWidget.init($cookiePolicyPopupWidget);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($ipRanges.length ) {
            UX.ipRanges.init($ipRanges);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($marc.length ) {
            UX.marc.init($marc);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($journal.length ) {
            UX.journal = new Journal($journal)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($backToTop.length ) {
            UX.backToTop.init($backToTop);
        }
    } catch (err) {
        console.error(err);
    }
    
tabsMain(UX);

}
import './webpack-public-path'
const importPromises = async () => {

    
    const { default: dynamicMain } = await import(/* webpackChunkName: 'dynamic-imports' */ './dynamic-imports');
    const promises = Object.values(await dynamicMain(UX));
    

    
    promises.push(await import(/* webpackChunkName: 'requestidlecallback-polyfill' */ 'requestidlecallback-polyfill'));
    let lazyPromise = new Promise(resolve => {
        window.requestIdleCallback(
            async () => {
                const { default: lazyMain } = await import(/* webpackChunkName: 'lazy-imports' */ './lazy-imports');
                await lazyMain(UX);
                resolve();
            },
            { timeout: 5000 }
        );
    });
    

    promises.push(lazyPromise);

    return Promise.all(promises);
};

const build = async (UX) => {
    
    const isIE = navigator.userAgent.indexOf('MSIE') !== -1
        || navigator.appVersion.indexOf('Trident/') > -1;
    if (isIE) {
        await import(/* webpackChunkName: 'ie-imports' */ './groups/_ie');
    }
    

    main(UX);
    await importPromises();
    try {
        UX.abLogger.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.enquireIt.init();
    } catch (err) {
        console.error(err);
    }
    
};

build(UX).then(() => {
    console.debug('JS LOADED');
});

